import { useEffect } from "react";

export function usePage({ title }) {
  useEffect(() => {
    document.title = title
      ? `${title} - GoPal Cashless Admin`
      : "GoPal Cashless Admin";
  }, [title]);
}
